<template>
  <v-container
    id="products"
    fluid
    class="page-container">
    <v-row>
      <v-col>

        <ProductList></ProductList>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';
  import ProductList from '@/components/Products/ProductList';

  export default {
    name: 'Products',
    extends: DataComponentBase,
    components: {
      ProductList,
    },

    data () {
      return {
      }
    },

    computed: {
    },

    methods: {
    },

  };
</script>
